<template>
	<div class="intro stage--cutsceneIntro" :style="{ 'background-image': backgroundImage }">

		<div class="header__container">
			<div class="header" style="position: relative">
				{{stageData.header}}
			</div>
			<div class="subHeader" style="position: relative">{{stageData.subheader}}</div>
			<div class="text" style="position: relative">
				{{stageData.story}}
			</div>
		</div>
		
		<Lottie
				:animationpath="baseUrl + stageData.visual"
				:audiopath="baseUrl + stageData.soundtrack"
				name="explenation-animation"
				loop="false"
				ratio="slice"
				autoplay="true"
				style="margin:auto; position: relative"
				v-if="visualExists && visualIsJson"
		/> 

		<!-- <div class="centered video-container" style="position: absolute" v-if="visualExists && visualIsVideo">
			<video id="cutscene_video" width="320" height="100%" controls="false" autoplay="true">
				<source :src="baseUrl + stageData.visual" type="video/mp4">
				Your browser does not support the video tag.
			</video>
		</div>
		<div class="centered" style="position: absolute" v-else-if="visualExists">
			<img
					:src="baseUrl + stageData.visual"
					class="visual"
			/>
		</div> -->

		<div class="media_player" v-if="visualExists && visualIsVideo">
			<div class="video_holder">

				<div class="cutscene_nameHolder hide" v-if="captionExists">
					<div class="nameHolder__collum caption">
						<h2 v-html="stageData.caption"></h2>
					</div>
					<div class="nameHolder__collum subcaption">
						<p v-html="stageData.subcaption"></p>
					</div>
				</div>

				<video preload="metadata" id="cutscene_video" crossorigin="anonymous" autoplay>
			    	
			    	<source :src="baseUrl + stageData.visual" type="video/mp4">

			      	<track kind="subtitles" srclang="nl" :src="baseUrl + stageData.subtitle" label="Nederlands" MIME-type='text/plain' default v-if="hasSubtitle">

			      Your browser does not support HTML5 video.
			    </video>

			    <div class="subtitles" v-if="hasSubtitle"></div>

			</div>
			
			<div class="video-controlls">
				<!-- <i class="play-btn fa fa-play-circle" onclick="playPause()"></i> -->
				<div id="play-btn" @click="togglePlay()">
					<i class="fa fa-play"></i>
				</div>
				<div id="mu-btn">
					<i class="fa fa-volume-up"></i>
				</div> 
				<div id="custom-seekbar">
				  <span></span>
				</div>
			</div>
		</div>


		<div class="centered" style="position: absolute" v-else-if="visualExists">
			<img
					:src="baseUrl + stageData.visual"
					class="visual"
			/>
		</div>

		

	</div>
</template>







<script>

	import { mapGetters , mapActions } from 'vuex';
	import { url} from '../../const/base';
	import Lottie from '../Lottie.vue';

	export default {

		components:{
			Lottie,
		},

		data(){
			return{
				headerReady: true,
				visualReady: true,
				storyReady: true,
				deviceHeight: 0,
				videoHeight: 0,
				offSet: 0,
				video: false,
				isPlaying: false,
				captionVisible: false,

			}
		},

		mounted(){

			this.showTransitorScore(false);

			if(this.visualIsVideo){

				console.log('video');

				this.setNextButtonAction(this.stopBlockTransition);

				var self = this;
				this.video = document.getElementById("cutscene_video");
				this.video.onplaying = function() {
					self.isPlaying = true;
				}
				this.video.onpause = function() {
					self.isPlaying = false;
				}
				this.video.onended = function() {
					self.showNextButton();
					self.isPlaying = false;
					self.hideText();
				};


				if(this.hasSubtitle){	
					this.video.addEventListener('loadedmetadata', this.videoMetaLoaded);
				}


				this.video.ontimeupdate = function(){
				  var percentage = ( self.video.currentTime / self.video.duration ) * 100;
				  $("#custom-seekbar span").css("width", percentage+"%");


				  if(percentage < 10 && percentage > 3 && !self.captionVisible){
					$(".cutscene_nameHolder").removeClass('hide');
				  	self.captionVisible = true;
				  }else if(percentage < 3 && !self.captionVisible){
				  	$(".cutscene_nameHolder").addClass('hide');
				  	self.captionVisible = false;
				  }

				  if(percentage > 20 && self.captionVisible){
				  	$(".cutscene_nameHolder").addClass('hide');
				  	self.captionVisible = false;
				  }

				};


				$("#custom-seekbar").on("click", function(e){
				    var offset = $(this).offset();
				    var left = (e.pageX - offset.left);
				    var totalWidth = $("#custom-seekbar").width();
				    var percentage = ( left / totalWidth );
				    var vidTime = self.video.duration * percentage;
				    self.video.currentTime = vidTime;
				});

			}else if(this.lastBlock){

				console.log('is lastBlock');

			}else if(this.lastStage){


				console.log('NO video');

				this.setNextButtonAction(this.stopBlockTransition).then(()=>{
					this.showNextButton();
				});
			}
			else{
				this.setNextButtonAction(this.toNextStage).then(()=>{
					this.showNextButton();
				});
			}

			$('#cutscene_video').prop('muted', false);

			$('#mu-btn').click( function (){
			  	$('#mu-btn').find('i').toggleClass('fa-volume-up fa-volume-off');
			    if( $('#cutscene_video').prop('muted') ) {
			          $('#cutscene_video').prop('muted', false);
			    } else {
			      $('#cutscene_video').prop('muted', true);
			    }
			});

		},

		methods:{
			...mapActions([
				"showNextButton",
				"setNextButtonAction",
				"toNextStage",
				"stopBlockTransition",
				"showTransitorScore",
			]),

			togglePlay() {
				$('#play-btn').find('i').toggleClass('fa-play fa-pause');
				console.log(this.isPlaying);
				console.log(this.video);
				if (this.isPlaying) {
				    this.video.pause();
				} else {
				    this.video.play();
				}
			},

			replaceText(text) {
		    	$('.subtitles').html(text);
		    },

		    showText() {
				$('.subtitles').addClass('show');
			},

			hideText() {
        		$('.subtitles').removeClass('show');
      		},

      		cueEnter(e) {
      			console.log('entering cue part');

		        this.replaceText(e.currentTarget.text);
		        this.showText();
	        },

		    cueExit() {
		    	//this.hideText();
		    },

		    videoMetaLoaded(e) {

		    	this.tracks  = this.video.textTracks[0];
				

				this.cues = this.tracks.cues;


				// console.log('videoMetaLoaded! Known cues:');
				// console.log(this.cues);

				// console.log('videoMetaLoaded! Known textTracks:');
				// console.log(this.video.textTracks[0]);


		  //   	var total = this.video.textTracks[0].cues.length;

		  //   	console.log('total:');
				// console.log(total);


		  //       for (var i in this.cues) {
		  //         	if (i < total) {
				// 		var cue = this.cues[i];
				// 		cue.onenter = this.cueEnter;
				// 		cue.onexit = this.cueExit;
				// 	}
		  //       }

		        this.tracks.mode = 'hidden';

		        var self = this;
		        this.video.textTracks[0].oncuechange = function(){

					//console.log(this.activeCues[0].text);

					if(typeof this.activeCues[0] !== 'undefined'){
						self.replaceText(this.activeCues[0].text);
		        		self.showText();
					}else{
						self.hideText();
					}

				};

	        },

		},

		computed: {

			baseUrl(){
				return url;
			},

			backgroundImage: function() {
		        return 'url('+ this.baseUrl + this.stageData.background + ')';
		    },

			...mapGetters([
				"stageData",
				"lastStage",
				"lastBlock",
			]),

			visualExists(){
				return this.stageData != null && this.stageData.visual != null;
			},

			visualIsJson(){
				if(this.stageData == null || this.stageData.visual == null) return false;
				let fileExtension = this.stageData.visual.substr(this.stageData.visual.lastIndexOf('.') + 1);
				return fileExtension.toLowerCase() == 'json';
			},

			visualIsVideo(){
				if(this.stageData == null || this.stageData.visual == null) return false;
				let fileExtension = this.stageData.visual.substr(this.stageData.visual.lastIndexOf('.') + 1);
				return fileExtension.toLowerCase() == 'mp4';
			},

			captionExists(){
				return this.stageData != null && this.stageData.caption != null;
			},

			hasSubtitle(){
				return this.stageData != null && this.stageData.subtitle != null;
			},
		},
	}
</script>


<style scoped>

.media_player {
	width: 100%;
	height: 100%;
}

.video_holder {
	position: relative;
	width: 100%;
	height: 100%;
}

.video-controlls {
	position: absolute;
	top: 30px;
	left: 0;
	right: 0;
}

#custom-seekbar {  
  cursor: pointer;
  height: 10px;
  margin-top: 20px;
  outline: thin solid #000;
  overflow: hidden;
  position: absolute;
  width: 60%;
  top: 0;
  left: 20%;
}

#custom-seekbar span {
  background-color: #6b6b6b;
  position: absolute;
  top: 0;
  left: 0;
  height: 10px;
  width: 0px;
}

.video_holder {
	z-index: 1;
}

.video-controlls {
	z-index: 2;
}

.video_holder video {
	width: 100%;
	height: auto;
	position: absolute;
	top: 50%;
	left: 50%;
	bottom: 0;
	transform: translate(-50%, -50%);
}

#play-btn {
	width: 20%;
    position: absolute;
    left: 0;
    text-align: center;
    top: 5px;
    color: #6b6b6b;
    font-size: 33px;
    height: unset;
}

#play-btn i {
	color: #6b6b6b;
	font-size: 33px;
}

#mu-btn {
	width: 20%;
    position: absolute;
    right: 0;
    text-align: center;
    top: 5px;
    color: #6b6b6b;
    font-size: 33px;
    height: unset;
}


	/*.video-container{
		top:0;
		right: 0;
		bottom: 0;
		left: 0;
	}

	.video-container video{
		width: 100%;
		height: auto;
		position: absolute;
		top: 50%;
		left: 50%;
		bottom: 0;
		transform: translate(-50%, -50%);
	}




	@media screen and (max-width: 375px) {
		.video-container video {
			height: 100%;
		}
	}*/
</style>


// WEBPACK FOOTER //
// src/components/cutscene/Index.vue